import {
  MultiSelect,
  type multiSelectLayouts,
} from '@/components/multi-select';
import {
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { useTranslations } from 'next-intl';
import { SetStateAction } from 'react';
import {
  type FieldValues,
  type Path,
  type UseFormReturn,
} from 'react-hook-form';

export const FormMultiSelect = <T extends FieldValues>({
  form,
  fieldName,
  fieldLabel,
  fieldPlaceholder,
  fieldOptions,
  className,
  layout = 'default',
  onSaveCb,
  onResetCb,
  onChange,
}: {
  form: UseFormReturn<T, any, undefined>;
  fieldName: Path<T>;
  fieldLabel?: string;
  fieldPlaceholder?: string;
  fieldOptions: { label: string; value: string }[];
  className?: string;
  required?: boolean;
  layout?: keyof typeof multiSelectLayouts;
  onSaveCb?: () => void;
  onResetCb?: () => void;
  onChange?: (
    value: SetStateAction<Record<'label' | 'value', string>[]>,
  ) => void;
}) => {
  const t = useTranslations();

  return (
    <FormField
      control={form.control}
      name={fieldName}
      render={({ field }) => (
        <FormItem className={className}>
          {fieldLabel && <FormLabel>{fieldLabel}</FormLabel>}
          <MultiSelect
            selected={field.value}
            options={fieldOptions}
            searchable={false}
            placeholder={fieldPlaceholder}
            layout={layout}
            onSaveCb={onSaveCb}
            onResetCb={onResetCb}
            t={t}
            {...field}
            onChange={(value) => {
              field.onChange(value);
              onChange?.(value);
            }}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
